<template>
    <div class="history-screen">
        <TitleCommon title="history" :isShowButtonBack="true" />
        <p class="count">{{ getTranslatedText(`Last ${ticketWillShow} ticket`) }}</p>
        <HistoryTransaction :limit="ticketWillShow" />
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';
import HistoryTransaction from '@/components/history/historyTransaction.vue';
import TitleCommon from '@/components/common/title/index.vue';

export default {
    mixins: [languageMixins],
    components: { HistoryTransaction, TitleCommon },
    data() {
        return {
            ticketWillShow: 5,
        };
    },
    created() {
        const config = this.$store.getters.getConfigOnFeature('history');
        this.ticketWillShow = config.ticketWillShow;
    },
    method: {},
};
</script>
<style lang="scss">
@import '@/public/scss/history/historyView.scss';
</style>
